import { useState, useMemo } from "react";
import { useTenant } from "../../../../hooks/useTenant";
import { useClassesData } from "./useClassesData";
import { useClassesHandlers } from "./useClassesHandlers";

/**
 * useClassesPage
 * Hook principal do módulo de Turmas (Fachada).
 * Orquestra a busca de dados, estado da grade e handlers do formulário.
 */
export const useClassesPage = () => {
    const { idTenant, user, loading: tenantLoading } = useTenant();

    // 1. Estados da Grade (Pequenos o suficiente para ficarem aqui)
    const [turn, setTurn] = useState("all");
    const [view, setView] = useState("week");
    const [referenceDate, setReferenceDate] = useState(new Date());

    // 2. Busca de Dados
    const {
        classes,
        activities,
        areas,
        employees,
        isInitialLoading,
        loadData
    } = useClassesData(idTenant, tenantLoading);

    // 3. Handlers de Ações e Formulário
    const {
        formState,
        setFormState,
        errors,
        touched,
        isSaving,
        handleSave,
        handleDelete,
        handleClassClick,
        handleStartTimeChange,
        handleDurationChange,
        handleWeekdayToggle,
        handleNew
    } = useClassesHandlers({
        idTenant,
        user,
        classes,
        activities,
        employees,
        areas,
        loadData
    });

    // 4. Transformação de dados para a Grade
    const schedulesForGrid = useMemo(() => classes.map(c => ({
        ...c,
        isClassTemplate: true,
        idClass: c.id,
    })), [classes]);

    return {
        // Formulário
        formState,
        setFormState,
        errors,
        touched,

        // Dados / Lookups
        classes,
        activities,
        areas,
        employees,
        schedulesForGrid,

        // Loading
        isInitialLoading,
        isSaving,
        isReady: !tenantLoading && !!idTenant,

        // Grade
        turn,
        setTurn,
        view,
        setView,
        referenceDate,
        setReferenceDate,

        // Ações
        handleSave,
        handleDelete,
        handleClassClick,
        handleNew,
        handleWeekdayToggle,
        handleStartTimeChange,
        handleDurationChange,
        loadData,
    };
};
